// extracted by mini-css-extract-plugin
export default {"Box":"filter-input-actions-module__Box--w34X1","Box_1":"filter-input-actions-module__Box_1--Q22WK"};